import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "16",
  viewBox: "0 0 18 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.9993 6.5V8.16667M8.9993 11.5H9.00763M3.22579 14.8333H14.7728C16.0558 14.8333 16.8577 13.4444 16.2162 12.3333L10.4427 2.33333C9.80117 1.22222 8.19742 1.22222 7.55592 2.33333L1.78242 12.3333C1.14092 13.4444 1.94279 14.8333 3.22579 14.8333Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }